import MarketingBlock from './marketingBlock'

export default MarketingBlock
